import { useTranslation } from 'react-i18next'
import i18next from 'i18next'

import { FormInputsType } from '@pages/FormCreateOrEdit/types'

import {
  GENERATOR_INPUT_TYPE,
  MAX_INPUT_LENGTH,
  TIME_LINE_OBJECT_TOTAL_ROW_BIND_TYPES,
} from '@constants'

type UseTotalsRowInputs = {
  titleFieldName: string
  scriptFieldName: string
  bindTypeFieldName: string
  handleChangeShowScriptDialog: (value?: boolean) => void
  handleOpenAddCommandsDialog: () => void
}

export const useTotalsRowInputs = (props: UseTotalsRowInputs) => {
  const { titleFieldName, scriptFieldName, bindTypeFieldName, handleChangeShowScriptDialog } = props

  const { t } = useTranslation()

  const inputs: FormInputsType[] = [
    {
      name: titleFieldName,
      inputType: GENERATOR_INPUT_TYPE.INPUT,
      placeholder: i18next.t('timeLinesCreateOrEdit.objectX.totals.title'),
      label: i18next.t('timeLinesCreateOrEdit.objectX.totals.title'),
      rules: { required: true, validate: value => value.trim().length !== 0 },
    },
    {
      name: bindTypeFieldName,
      inputType: GENERATOR_INPUT_TYPE.AUTOCOMPLETE,
      placeholder: t('placeholder.bindType'),
      label: t('columnInputs.bindType.label'),
      autocompleteOptions: TIME_LINE_OBJECT_TOTAL_ROW_BIND_TYPES,
    },
    {
      name: scriptFieldName,
      inputType: GENERATOR_INPUT_TYPE.TEXTAREA,
      placeholder: t('timeLinesCreateOrEdit.objectX.value'),
      label: t('timeLinesCreateOrEdit.objectX.value'),
      maxLengthInput: MAX_INPUT_LENGTH,
      readOnly: true,
      rows: 10,
      rules: {
        maxLength: MAX_INPUT_LENGTH,
      },
      formInputContainerSx: {
        justifyContent: 'flex-end !important',
        gap: 1,
        pb: 2,
      },
      additionalBtn: {
        isEnabled: true,
        text: 'edit',
        color: 'primary',
        variant: 'contained',
        onClick: () => handleChangeShowScriptDialog(true),
      },
    },
  ]

  return {
    inputs,
  }
}
